import api from "../api/api";
const BASE_URL = import.meta.env.VITE_APP_API_URL;

export const vincularAparelhosService = {
  // Método para buscar os detalhes completos de uma máquina por ID

  buscarMaquinaId: async (id) => {
    try {
      const url = `${BASE_URL}/maquinas/${id}/ficha-completa`;
      const response = await api.get(url);

      if (response.status === 200 && response.data && response.data.id) {
        return response.data;
      } else {
        throw new Error("Dados da máquina não estão completos.");
      }
    } catch (error) {
      if (error.response) {
        if (error.response.status === 404) {
          // Mensagem específica para 404
          throw new Error("Máquina não encontrada.");
        } else {
          // Outras mensagens de erro da API
          throw new Error(error.response.data.message || "Erro ao obter máquina por id.");
        }
      } else if (error.request) {
        // Erro de rede
        throw new Error("Erro de rede. Por favor, verifique sua conexão.");
      } else {
        // Outros erros
        throw new Error(error.message || "Erro ao obter máquina por id.");
      }
    }
  },

  // Método para listar todas as máquinas com parâmetros de filtro, se necessário
  async obterTodos(params) {
    try {
      const url = `${BASE_URL}/maquinas-lista-completa`;
      const response = await api.get(url, { params });
      return response.data;
    } catch (error) {
      console.error("Erro ao obter lista de máquinas:", error);
      throw new Error("Erro ao obter lista de máquinas.");
    }
  },
  buscarAparelhoId: async (id) => {
    try {
      const url = `${BASE_URL}/aparelhos-id/${id}`;
      const response = await api.get(url);

      if (response.status === 200 && response.data && response.data.id) {
        return response.data;
      } else {
        throw new Error("Dados do aparelho não estão completos.");
      }
    } catch (error) {
      if (error.response) {
        if (error.response.status === 404) {
          // Mensagem específica para 404
          throw new Error("Aparelho não encontrado.");
        } else {
          // Outras mensagens de erro da API
          throw new Error(error.response.data.message || "Erro ao obter aparelho por id.");
        }
      } else if (error.request) {
        // Erro de rede
        throw new Error("Erro de rede. Por favor, verifique sua conexão.");
      } else {
        // Outros erros
        throw new Error(error.message || "Erro ao obter aparelho por id.");
      }
    }
  },


  // Método para adicionar um aparelho a uma máquina
  async adicionarAparelho(idMaquina, idAparelho) {
    try {
      // Definindo o endpoint com idMaquina na URL e enviando id_aparelho no corpo da requisição
      const url = `${BASE_URL}/aparelhos-adicionar-maquina/${idMaquina}/aparelhos`;

      // Fazendo a requisição POST com o id_aparelho no corpo
      const response = await api.post(
        url,
        { id_aparelho: idAparelho },
        {
          headers: {
            "Content-Type": "application/json", // Garante que o corpo seja interpretado como JSON
          },
        }
      );

      // Retornando os dados da resposta
      return response.data;
    } catch (error) {
      // Tratamento de erro em caso de falha
      console.error("Erro ao adicionar aparelho:", error);
      throw new Error("Erro ao adicionar aparelho.");
    }
  },

  // No arquivo vincularAparelhosService.js
  async removerAparelho(idAparelho) {
    try {
      const url = `${BASE_URL}/aparelhos-remover-maquina/${idAparelho}`;
      const response = await api.post(url, { id_aparelho: idAparelho });
      return response.data;
    } catch (error) {
      console.error("Erro ao remover aparelho:", error);
      throw new Error("Erro ao remover aparelho.");
    }
  },
};
